module.exports = __webpack_public_path__ + "static/img/logo-3.2825ba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/partners/logo-3.png
// module id = P7zn
// module chunks = 3